/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import MEMBER_NOTIFICATION_CONFIG from 'config/member_emails.config';
import { getEmailIconByType } from 'routes/onboard/member_email/helpers';

import { styles } from './styles';

const { KEYMAP } = MEMBER_NOTIFICATION_CONFIG;

const MemberNotificationItem = ({ item, onEdit, onDelete }) => {
	const handleEdit = () => {
		onEdit(item);
	};

	const handleDelete = () => {
		onDelete(item);
	};

	const IconComponent = getEmailIconByType(item.email_type);

	return (
		<ListItem key={item.id} sx={styles.listItem}>
			<ListItemAvatar>
				<Avatar>
					<IconComponent />
				</Avatar>
			</ListItemAvatar>
			<ListItemText
				primaryTypographyProps={{ color: 'primary.main' }}
				secondaryTypographyProps={{ variant: 'caption' }}
				primary={KEYMAP[item.email_type]}
				secondary={item.email_subject}
			/>
			<ListItemSecondaryAction>
				<IconButton edge="end" aria-label="delete" onClick={handleEdit}>
					<EditIcon />
				</IconButton>
				<IconButton edge="end" aria-label="delete" onClick={handleDelete}>
					<CloseIcon />
				</IconButton>
			</ListItemSecondaryAction>
		</ListItem>
	);
};
export default MemberNotificationItem;
